import React from 'react';

function resolveBadge(challenge, isSelfChallenge) {
	if (!isSelfChallenge) return null;

	if (challenge.community_challenge_id) {
		return {
			label: 'Community challenge',
			text: 'Community',
			bgClass: 'bg-cyan-600 dark:bg-cyan-500'
		};
	}

	return {
		label: 'Self challenge',
		text: 'Self',
		bgClass: 'bg-purple-600 dark:bg-purple-500'
	};
}

export default function ChallengeTypeBadge({ challenge, isSelfChallenge }) {
	const badge = resolveBadge(challenge, isSelfChallenge);
	if (!badge) return null;

	return (
		<span
			className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-semibold text-white ${badge.bgClass}`}
			aria-label={badge.label}
		>
			{badge.text}
		</span>
	);
}
